import { combineReducers } from "redux";
import { thoiKhoaBieuChiTietReducer } from "./thoiKhoaBieuChiTietReducer";
import { thoiKhoaBieuReducer } from "./thoiKhoaBieuReducer";

export const thoiKhoaBieuReducerWrapper = combineReducers({
    thoiKhoaBieu: thoiKhoaBieuReducer,
    thoiKhoaBieuChiTiet: thoiKhoaBieuChiTietReducer
})